import { IvsMediaPlayer } from '../hooks/use-resource-pool';

type MediaVideo = HTMLVideoElement | IvsMediaPlayer | null;

/*
	The point of the below methods is so we can call play / pause, set time,
	etc. on video elements without having to think about the differences
	between MP4, HLS, or other formats.
*/

// Type predicate for video
const isHtmlVideo = (video: MediaVideo): video is HTMLVideoElement => {
	return (video as HTMLVideoElement).paused !== undefined;
};

export const getVideoElPlaying = (video: MediaVideo): boolean => {
	if (video) {
		if (isHtmlVideo(video)) {
			return !video.paused;
		}

		return !video.isPaused();
	}

	return false;
};

export const setVideoElPlaying = (
	video: MediaVideo,
	shouldBePlaying: boolean,
): boolean => {
	if (video) {
		if (shouldBePlaying) {
			video.play();
		} else {
			video.pause();
		}

		return true;
	}

	return false;
};

export const getVideoElDuration = (video: MediaVideo): number => {
	if (video) {
		if (isHtmlVideo(video)) {
			return video.duration;
		}

		return video.getDuration();
	}

	return 0;
};

export const getVideoElElapsed = (video: MediaVideo): number => {
	if (video) {
		if (isHtmlVideo(video)) {
			return video.currentTime;
		}

		return video.getPosition();
	}

	return 0;
};

export const setVideoElElapsed = (
	video: MediaVideo,
	elapsed: number,
): boolean => {
	if (video) {
		if (isHtmlVideo(video)) {
			video.currentTime = elapsed;
		} else {
			video.seekTo(elapsed);
		}

		return true;
	}

	return false;
};
